// extracted by mini-css-extract-plugin
module.exports = {"container":"Blog-module--container--2OAZD"};